import { clinicianName } from './clinicianName.js'
/**
 * caseFor — s110 (Dr. Rami, TestFlight build 77, 2026-10-17: "the flow to start a case for the physician needs a bit
 * of design work ... as they proceed to build their case"; mockup "Orella Doctors Start Case" S4, approved).
 *
 * Who the case being built is FOR, when the patient started it from a doctor (StartCaseSheet): the office saved by
 * utils/preferredOffice (a directory doctor, faxed) or the Orella doctor in 'orella-preferred-doctor'. READ ONLY:
 * unlike readPreferredOffice this never binds the record to a case (the share hub still does that). `forget` drops
 * both, so the patient picks a doctor at the share hub as usual.
 * PURE apart from the storage parameter; no imports so scripts/check-case-for.mjs runs it under plain node.
 */
export const PREFERRED_OFFICE_KEY = 'orella-preferred-office'   // = utils/preferredOffice (the gate holds them equal)
export const PREFERRED_DOCTOR_KEY = 'orella-preferred-doctor'
const MAX_AGE_MS = 24 * 60 * 60 * 1000

const session = () => {
  try { return typeof window !== 'undefined' ? window.sessionStorage : null } catch (_) { return null }
}

function parse(store, key) {
  try { return JSON.parse(store.getItem(key) || 'null') } catch (_) { return null }
}

/** { kind: 'office'|'orella', name, specialty } or null. */
export function caseForTarget(caseId, store = session(), now = Date.now()) {
  if (!store) return null
  const rec = parse(store, PREFERRED_OFFICE_KEY)
  if (rec && rec.office && rec.office.npi && Number.isFinite(rec.savedAt) && now - rec.savedAt <= MAX_AGE_MS
      && (!rec.caseId || (caseId && rec.caseId === String(caseId)))) {
    const o = rec.office
    return { kind: 'office', name: `${o.name || ''}${o.credential ? `, ${o.credential}` : ''}`.trim(), specialty: o.specialty || '' }
  }
  const d = parse(store, PREFERRED_DOCTOR_KEY)
  if (d && d.id) {
    const name = clinicianName(d)
    return { kind: 'orella', name, specialty: d.specialty || '' }
  }
  return null
}

export function forgetCaseFor(store = session()) {
  try { store && store.removeItem(PREFERRED_OFFICE_KEY) } catch (_) { /* nothing kept */ }
  try { store && store.removeItem(PREFERRED_DOCTOR_KEY) } catch (_) { /* nothing kept */ }
}

export function caseForInitials(name) {
  const parts = String(name || '').replace(/^dr\.?\s+/i, '').replace(/,.*$/, '').split(/\s+/).filter(Boolean)
  return (((parts[0] || '')[0] || '') + ((parts[parts.length - 1] || '')[0] || '')).toUpperCase() || 'DR'
}
